export const Utils = {
    FormatCurrency: (amount: number, currency: string): string => {
        let symbol = "";
        switch (currency) {
            case "ZAR":
                symbol = "R";
                break;
            case "EUR":
                symbol = "€";
                break;
            case "USD":
                symbol = "$";
                break;
            case "GBP":
                symbol = "£";
                break;
        }
        return `${symbol}${Number(amount).toFixed(2)}`;
    },
    GetAlias: (): string => {
        const paths = window.location.pathname.split('/');
        const reservedRoutes = ["products", "product", "admin", "orders", "order", "login", "register", "userprofile", "cart", "checkout", "ordersuccess", "", "d", "setup", "storeoperator", "instructions", "paymentproviders", "reset-password"];

        if (paths.length > 1 && reservedRoutes.indexOf(paths[1].toLowerCase()) === -1) {
            return paths[1].toLowerCase();
        }

        return "";
    },
    GetDomain: (): string => {
        const parts = window.location.hostname.split('.');
        return parts.length > 2 ? parts[parts.length - 3] : parts[0];
    },
    GetUrl: (link: string) => {
        var alias = Utils.GetAlias();
        return alias ? `/${alias}${link}` : link;
    },
    GetFullUrl: (link: string) => {
        return `${window.location.origin}${Utils.GetUrl(link)}`;
    },
    FormatPhoneNumber: (phoneCode: string, phoneNumber: string) => {
        return `${phoneCode}${phoneNumber.startsWith('0') ? phoneNumber.substring(1).replace(" ", "") : phoneNumber.replace(" ", "")}`;
    },
    CopyToClipboard: (text: string) => {
        navigator.clipboard.writeText(text).then(() => {
            console.log('Text copied to clipboard');
        }).catch(err => {
            console.error('Could not copy text: ', err);
        });
    },
    IsColorLight: (hex: string) => {
        // Remove hash if present
        hex = hex.replace(/^#/, '');

        // Convert 3-digit hex to 6-digit
        if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
        }

        // Convert to RGB
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Calculate luminance
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

        // Return true if light, false if dark
        return luminance > 186;
    }

}
